import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import closeIcon from "../../../assets/images/icons/close.png";

import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";

import L48D from "../../../../src/assets/images/game_logo/Icon_48D.svg";
import L36D from "../../../../src/assets/images/game_logo/Icon-36D.svg";
import L24D from "../../../../src/assets/images/game_logo/Icon-24D.svg";
import L12D from "../../../../src/assets/images/game_logo/Icon_12D.svg";
import LdragonTiger from "../../../../src/assets/images/game_logo/Icon-DragonTiger.svg";
import LpockerDice from "../../../../src/assets/images/game_logo/heart.svg";
import SciboLogo from "../../../../src/assets/images/game_logo/sicboLogo.svg";
import SuperWheel from "../../../../src/assets/images/game_logo/super_wheel.svg";
import { formatPrice } from "../../NumberFormat";


const MultibetPopup = (props) => {

  const { index, multibetCard, handleGameSelected } = props
  const [MultiBetPopupData, setMultiBetPopupData] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false)
  const gameIcon = {
    "48D": L48D,
    "36D": L36D,
    "24D": L24D,
    "12D": L12D,
    DT: LdragonTiger,
    PD: LpockerDice,
    SB: SciboLogo,
    WH: SuperWheel
  };

  // const backgroundImage = {
  //   '48D': Bg2,
  //   '36D': Bg1,
  //   '24D': Bg3,
  //   '12D': Bg4,
  //   'WH': Bg3,
  //   'SB': Bg2,
  //   'PD': Bg1,
  //   'DT': Bg5,
  // };

  // api for MultiBet Popup

  const fetchMultiBetPopupData = () => {
    makeAjax(url.DINGDONG_API.listGameRoom).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setMultiBetPopupData(response.data.rooms);
    });
  };
  useEffect(() => {
    fetchMultiBetPopupData();
  }, []);


  const handleLimits = (room, limit) => {

    const fetchCheckGameStatus = () => {
      let reqData = {
        roomName: room.room_name,
        gameId: room.game_id
      };


      makeAjax(url.DINGDONG_API.checkGameStatus, reqData).then((response) => {
        if (response.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }

        for (let card of multibetCard) {
          if (room.game_code === card.item_data.game_code &&
            room.room_name === card.item_data.room_name) {
            // showMessage("The Chosen Game already exist , Place choose another type of game.  ", "error", "Message")
            setShowPopUp(true)
            return null;
          }
        }

        let tempRoom = { ...room };
        tempRoom["selected_limit"] = limit;
        tempRoom["game_icon"] = gameIcon[room.game_code];
        handleGameSelected(tempRoom, index);
      });
    };

    fetchCheckGameStatus();
  };

  const closeOnlinePopup = () => {
    setShowPopUp(false)
  }

  return (
    <div className="multipopup_game_conainer">
      {MultiBetPopupData.map((room, innerIndex) => (
        room.game_code !== "WH" && room.game_allowed === true
          ?
          <div className="multipopup_game" key={innerIndex} onClick={() => handleLimits(room, room.room_limit[0])}>
            {/* <div className="multipopup_limit_popup">
              <ul>
                {room.room_limit.map((limit, inInIndex) => {
                  return (
                    <li key={inInIndex}>
                      <p>{room.room_name}</p>
                      <p onClick={() => handleLimits(room, limit)}>
                        {formatPrice(limit.unit_list[0].value)} - {formatPrice(limit.unit_list[1].value)}
                      </p>
                    </li>
                  );
                })}
              </ul>
            </div> */}
            <div className="multipopup_game_bg">
              <div className="logo">
                <img src={gameIcon[room.game_code]} alt={room.game_code} />
              </div>
            </div>
            <div className="multipopup_game_name_type">
              <p>{room.game_name.replace("Dingdong", "")}</p>
            </div>
          </div>
          : null
      ))}
      {showPopUp && (
        <>
          <div className="notification_sub_popup_overlay" ></div>
          <div className="notification_sub_popup">
            <div className="notification_Details conn_lost_detail">
              <div className="conn_lost_inner">
                <span style={{ color: "white" }}>{props.t("choose_game_already_exist")}</span>
                <div className="notification_body">
                  <button className="btn2" onClick={closeOnlinePopup}>OK</button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default withTranslation()(MultibetPopup);
